import startsWith from 'lodash/startsWith';

import {
  IB_FETCH_INTEGRATIONS_START,
  IB_FETCH_INTEGRATIONS_SUCCESS,
  IB_FETCH_INTEGRATIONS_FAILURE,
  IB_FETCH_PLAN_START,
  IB_FETCH_PLAN_SUCCESS,
  IB_FETCH_PLAN_FAILURE,
  IB_FETCH_FORMS_START,
  IB_FETCH_FORMS_SUCCESS,
  IB_FETCH_FORMS_FAILURE,
  IB_FETCH_AGENTS_START,
  IB_FETCH_AGENTS_SUCCESS,
  IB_FETCH_AGENTS_FAILURE,
  IB_FETCH_ENDPOINTS_START,
  IB_FETCH_ENDPOINTS_SUCCESS,
  IB_FETCH_ENDPOINTS_FAILURE,
  IB_SAVE_INTEGRATION_START,
  IB_SAVE_INTEGRATION_SUCCESS,
  IB_SAVE_INTEGRATION_FAILURE,
  IB_FETCH_IASERVICES_SUCCESS,
  IB_FETCH_IASERVICES_START,
  IB_FETCH_IASERVICES_FAILURE,
  IB_GWT_INTEGRATION_FAIL_SOLVE,
  IB_RESET,
} from '../../actions/integrationBuilder';

export const INITIAL_STATE = {
  error: null,
  saveSuccess: false,
};

export default function loadStateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case IB_FETCH_INTEGRATIONS_START:
    case IB_FETCH_INTEGRATIONS_SUCCESS:
    case IB_FETCH_PLAN_START:
    case IB_FETCH_PLAN_SUCCESS:
    case IB_FETCH_FORMS_START:
    case IB_FETCH_FORMS_SUCCESS:
    case IB_FETCH_AGENTS_START:
    case IB_FETCH_AGENTS_SUCCESS:
    case IB_FETCH_ENDPOINTS_START:
    case IB_FETCH_ENDPOINTS_SUCCESS:
    case IB_SAVE_INTEGRATION_START:
    case IB_FETCH_IASERVICES_START:
    case IB_FETCH_IASERVICES_SUCCESS:
      return {
        error: null,
        saveSuccess: false,
      };
    case IB_SAVE_INTEGRATION_SUCCESS:
      return {
        error: null,
        saveSuccess: true,
      };
    case IB_FETCH_INTEGRATIONS_FAILURE:
    case IB_FETCH_PLAN_FAILURE:
    case IB_FETCH_FORMS_FAILURE:
    case IB_FETCH_AGENTS_FAILURE:
    case IB_FETCH_ENDPOINTS_FAILURE:
    case IB_FETCH_IASERVICES_FAILURE:
    case IB_SAVE_INTEGRATION_FAILURE:
      return {
        error: action.payload,
        saveSuccess: false,
      };
    case IB_GWT_INTEGRATION_FAIL_SOLVE:
      return {
        error: {
          code: 404,
          message: 'Cannot find integration with UUID.',
        },
        saveSuccess: false,
      };
    case IB_RESET: {
      return INITIAL_STATE;
    }
    default:
      if (startsWith(action.type, 'IB_')) {
        return {
          error: null,
          saveSuccess: false,
        };
      }
      return state;
  }
}
